module.exports = __webpack_public_path__ + "media/qrcode-access-allowed.9706c1e4.wav";